import { ProctoringEventType } from '@/constants/enums'
import type { InterviewStreamPlugin } from '../interview-stream-host.type'

export function createScreenShareMonitorPlugin(): InterviewStreamPlugin {
    let ctxRef: Parameters<NonNullable<InterviewStreamPlugin['onStreamsUpdated']>>[0] | null = null
    let removeEndedListener: (() => void) | null = null

    const cleanup = () => {
        removeEndedListener?.()
        removeEndedListener = null
    }

    const attach = (ctx: Parameters<NonNullable<InterviewStreamPlugin['onStreamsUpdated']>>[0]) => {
        cleanup()
        const track = ctx.streams.screenTrack
        if (!track) {
            return
        }

        const onEnded = () => {
            ctx.addProctoringEvent(ProctoringEventType.ScreenShareStopped)
            ctx.notifyScreenShareEnded()
        }

        track.addEventListener('ended', onEnded)
        removeEndedListener = () => track.removeEventListener('ended', onEnded)
    }

    return {
        id: 'screen-share-monitor',
        start(ctx) {
            ctxRef = ctx
            attach(ctx)
        },
        stop() {
            cleanup()
            ctxRef = null
        },
        onStreamsUpdated(ctx) {
            ctxRef = ctx
            attach(ctx)
        },
    }
}
